import { render, staticRenderFns } from "./kyc-certification.vue?vue&type=template&id=5da87ab2&scoped=true&"
import script from "./kyc-certification.vue?vue&type=script&lang=js&"
export * from "./kyc-certification.vue?vue&type=script&lang=js&"
import style0 from "./kyc-certification.vue?vue&type=style&index=0&lang=scss&module=true&"
import style1 from "./kyc-certification.vue?vue&type=style&index=1&id=5da87ab2&scoped=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "5da87ab2",
  null
  
)

export default component.exports